import { Fragment } from 'react';
import TemplateModal from './templateModal';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';

const ViewExistingReportModal = ({ isVisible, onCancel, onConfirm, onClose, price }) => {
    const { t } = useTranslation('confirmModal');

    return (
        <TemplateModal
            title={t('title.existing-report')}
            content={
                <Fragment>
                    <p style={{ margin: spacing[0.5] }}>{t('message.existing-report', { count: price })}</p>
                </Fragment>
            }
            isVisible={isVisible}
            onCancel={onCancel}
            onClose={onClose}
            onConfirm={onConfirm}
            confirmText={t('buttons.yes')}
            cancelText={t('buttons.buy-new')}
        />
    );
};

export default ViewExistingReportModal;
